import { render, staticRenderFns } from "./TransportCosts.vue?vue&type=template&id=2254b1b2&scoped=true&"
import script from "./TransportCosts.vue?vue&type=script&lang=js&"
export * from "./TransportCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254b1b2",
  null
  
)

component.options.__file = "TransportCosts.vue"
export default component.exports